var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseSched = function SvgCloseSched(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.75 31.75"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 101",
    d: "M27.1 4.651a15.869 15.869 0 0 0-22.448 0 15.869 15.869 0 0 0 0 22.448 15.869 15.869 0 0 0 22.448 0 15.869 15.869 0 0 0 0-22.448Zm-1.316 21.133A14.014 14.014 0 1 1 5.966 5.966a14.014 14.014 0 0 1 19.818 19.818Z",
    fill: "#24272b"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 102",
    d: "m22.876 21.556-5.686-5.68 5.68-5.68a.93.93 0 0 0-1.315-1.315l-5.68 5.68-5.68-5.68a.93.93 0 0 0-1.315 1.315l5.68 5.68-5.68 5.68a.925.925 0 0 0 0 1.315.928.928 0 0 0 1.315 0l5.68-5.68 5.68 5.68a.932.932 0 0 0 1.321-1.315Z",
    fill: "#24272b"
  }))))));
};
export default SvgCloseSched;